import BaseApiRequest from "./BaseApiRequest";
import { GET_APPLICANT_LIST_URL } from "../ApiUrls";
import { METHOD } from "../Constants";
import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class GetApplicantListRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  getMethod = () => this.method;

  getUrl = () => {
    return getCurrentUserParameters(
      `${GET_APPLICANT_LIST_URL}?t=${new Date().getTime()}`
    );
  };

  getBody = () => this.body;
}
